import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgArrowDown = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 25 25" {...props}><Path fill="currentColor" d="m12.5 25 10.3-10.1-1.9-1.9-7 7V0h-2.8v20l-7-7-1.9 1.9z" /></Svg>;
const Memo = memo(SvgArrowDown);
export default Memo;